import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isNil } from 'lodash';
import { endOfMonth, format, startOfMonth } from 'date-fns';
import { trackError } from 'utils/helpers';
import { FORMAT_QT_DATE } from 'utils/helpers/datetime';
import { PRICING_SECTION, setBookability } from 'redux/actions/availability';
import { useDateRangeBookabilityQuery } from 'redux/api_slice/availability';

const formatDate = (date) => format(date, FORMAT_QT_DATE);

// Get the price for the current month and display it on calendar
export const useCalendarPrice = ({
  resource,
  currentMonth,
  passengerTypeIDs,
}) => {
  const pricingSection = PRICING_SECTION.calendar;
  const fromDate = formatDate(startOfMonth(currentMonth));
  const toDate = formatDate(endOfMonth(currentMonth));
  const dispatch = useDispatch();
  const { data, isFetching, error } = useDateRangeBookabilityQuery(
    {
      resourceIds: [resource],
      passengerTypeNumbers: { [passengerTypeIDs[0]]: 1 },
      fromDate,
      toDate,
    },
    { skip: isNil(resource) }
  );

  // Update redux store
  useEffect(() => {
    if (!isNil(data)) {
      const temp = { json: data, pricingSection };
      dispatch(setBookability(temp));
    }
  }, [data, dispatch, pricingSection]);

  useEffect(() => {
    if (!isNil(error)) {
      trackError(error);
    }
  }, [error]);

  return { isFetching };
};
